<template>
    <div class="flex items-center justify-items-end">
        <div class="" :class="subItem ? 'flex-1/3 md:flex-1/4 lg:flex-3/13 xl:flex-3/7 2xl:flex-2/5' : 'flex-1/6 xl:flex-2/6'">
            <div v-if="type === 'tick'" class="bg-white rounded-full text-pohvBlue flex ml-[63%]" :class="subItem ? 'h-8 w-8' : 'h-12 w-12 lg:h-15 lg:w-15'">
                <CheckIcon class="m-auto flex" :class="subItem ? 'h-6 w-6' : 'h-9 w-9 lg:h-9 lg:w-9'" />
            </div>
            <div v-else-if="type === 'empty'" class="border-white border-1 rounded-full text-pohvBlue flex ml-[63%]" :class="subItem ? 'h-8 w-8' : 'h-12 w-12 lg:h-15 lg:w-15'"></div>
            <div v-else class="border-white border-1 rounded-full text-pohvBlue flex ml-[63%]" :class="subItem ? 'h-8 w-8' : 'h-12 w-12 lg:h-15 lg:w-15'">
                <div class="h-8 w-8 m-auto bg-white rounded-full flex" />
            </div>
        </div>
        <div class="flex-1/2 text-white ml-10 xl:ml-1 text-sm lg:text-base" :class="subItem && 'text-xs lg:text-sm'"><strong>{{ title }}</strong><br/>{{ description }}</div>
    </div>
    <div v-if="showBorder" class="flex items-center justify-items-end">
        <div class="flex-1/12 md:flex-1/12 lg:flex-1/7 xl:flex-2/9 -ml-3 lg:ml-0 lg:mr-6 xl:mr-1">
            <div class=" flex ml-[40%] xl:ml-[59%]"><div class="bg-white w-0.25 ml-10" :class="smallBorder ? 'h-6' : 'h-12'"></div></div>
        </div>
        <div class="flex-2/5"></div>
    </div>
</template>

<script setup lang="ts">
import { CheckIcon } from '@heroicons/vue/24/outline'

defineProps<{
  title?: string
  description?: string
  type: 'empty' | 'dot' | 'tick'
  showBorder: boolean
  smallBorder: boolean
  subItem: boolean
}>()

</script>
